import { Controller } from "@hotwired/stimulus";

// This could be abstracted to replace the jquery input_toggle_on_change helper
// We need to access the textarea within the YAML field editor, in order to make
// the field required/not required as it's shown/hidden.

// Connects with data-controller="secrets-toggle-policy"
export default class extends Controller {
  static targets = ["input", "hiddenInput", "hideable", "textarea"];
  static values = { name: String };

  declare hideableTarget: HTMLElement;
  declare inputTarget: HTMLInputElement;
  declare hiddenInputTarget: HTMLInputElement;
  declare textareaTarget: HTMLInputElement;
  declare nameValue: string;
  declare hasTextareaTarget: boolean;

  // once the textarea exists in the DOM we want to call evaluate
  // so we can get in the right initial state, either do nothing
  // or hide the field immediately. The textarea is loaded in after
  // the rest of the targets load, so we can't do this on `connect` or
  // `initialize`
  textareaTargetConnected() {
    this.evaluate();
  }

  evaluate() {
    if (
      !this.hideableTarget ||
      !this.inputTarget ||
      !this.hasTextareaTarget ||
      !(this.inputTarget instanceof HTMLInputElement)
    ) {
      return;
    }

    const target = this.inputTarget;

    // if the target is checked, set the whole hideable target
    // to be hidden, it's input not required, and make the name junk so
    // it's value is thrown away on form submission
    if (target.checked === true) {
      this.textareaTarget.setAttribute("name", "hidden_textarea");
      this.textareaTarget.removeAttribute("required");
      this.hideableTarget.classList.add("hidden");

      // while it's hidden, give it's name to another element that will only
      // ever be empty
      this.hiddenInputTarget.setAttribute("name", this.nameValue);

      // if it's unchecked, put it back as it was
    } else {
      this.hideableTarget.classList.remove("hidden");
      this.textareaTarget.setAttribute("required", "true");
      this.textareaTarget.setAttribute("name", this.nameValue);

      // and we don't need the dummy input for submission
      this.hiddenInputTarget.setAttribute("name", "hidden_textarea");
    }
  }
}
